import { commonDate, dateTime } from 'src/helpers/index'

const initForm = {
  category1: null,
  category2: null,
  category3: null,
  brand: null,
  subCategory: null,
  name: null,
  sku: null,
  variants: [],

  discountTier: [],
  minQtyFreeShipping: null,
  maxQtyFreeShipping: null,

  weight: null,
  unit: null,
  width: null,
  height: null,
  length: null,

  images: [],
  description: null,
  specification: null,

  isPopular: null,
  isBestSeller: null,
  isFluctuation: null
}

export default function () {
  return {
    table: {
      unit: {
        visibleColumns: [
          'name'
        ],
        columns: [
          {
            name: 'name',
            field: (row) => {
              return row.name
            },
            label: 'Nama Satuan',
            sortable: true,
            align: 'left',
            rowClass: 'text-left text-primary'
          }
        ]
      },

      brand: {
        visibleColumns: [
          'name',
          'description'
        ],
        columns: [
          {
            name: 'name',
            field: (row) => {
              return row.name
            },
            label: 'Nama Satuan',
            sortable: true,
            align: 'left',
            rowClass: 'text-left text-primary'
          },
          {
            name: 'description',
            field: (row) => {
              return row.description || '-'
            },
            label: 'Deskripsi',
            sortable: true,
            align: 'left',
            rowClass: 'text-left'
          }
        ]
      },

      variant: {
        visibleColumns: [
          'name'
        ],
        columns: [
          {
            name: 'name',
            field: (row) => {
              return row.name
            },
            label: 'Jenis Varian',
            sortable: true,
            align: 'left',
            rowClass: 'text-left text-primary'
          }
        ]
      },

      discount: {
        visibleColumns: [
          'name',
          'percent'
        ],
        columns: [
          {
            name: 'name',
            field: (row) => {
              return row.name
            },
            label: 'Nama',
            sortable: true,
            align: 'left',
            rowClass: 'text-left text-primary'
          },
          {
            name: 'percent',
            field: (row) => {
              return row.discount + '%'
            },
            label: 'Persentase Diskon',
            sortable: true,
            align: 'left',
            rowClass: 'text-left'
          }
        ]
      },

      discountHistory: {
        columns: [
          {
            name: 'createdAt',
            field: (row) => {
              // return row.created_at
              return `<div>${commonDate({
                date: row.created_at
              })}</div>
              <div class="text-caption text-grey-7">${dateTime(row.created_at)}</div>`
            },
            label: 'Tanggal Diubah',
            sortable: true,
            align: 'left',
            rowClass: 'text-left'
          },
          {
            name: 'discount',
            field: (row) => {
              return row.discount
            },
            label: 'Persentase Diskon',
            sortable: true,
            align: 'center',
            rowClass: 'text-center'
          },
          {
            name: 'actore',
            field: (row) => {
              // return row.user_name
              return `<div>${row.user_name}</div>
              <div class="text-primary text-caption">${row.role_name}</div>`
            },
            label: 'Aktor',
            sortable: true,
            align: 'left',
            rowClass: 'text-left'
          }
        ]
      },

      marginPercentage: {
        visibleColumns: [
          'name',
          'marginRetail',
          'marginBusiness',
          'marginBusinessTermin'
        ],
        columns: [
          {
            name: 'name',
            field: (row) => {
              return `<a href="javascript:;" data-row="${encodeURIComponent(JSON.stringify(row))}" class="preview-margin-detail">${row.name}</a>`
            },
            label: 'Nama Kategori 3',
            sortable: true,
            align: 'left',
            rowClass: 'text-left text-primary'
          },
          {
            name: 'marginRetail',
            field: (row) => {
              return row.margin_retail + '%'
            },
            label: 'Retail - Tunai',
            sortable: true,
            align: 'left',
            rowClass: 'text-left'
          },
          {
            name: 'marginBusiness',
            field: (row) => {
              return row.margin_business + '%'
            },
            label: 'Bisnis - Tunai',
            sortable: true,
            align: 'left',
            rowClass: 'text-left'
          },
          {
            name: 'marginBusinessTermin',
            field: (row) => {
              return row.margin_business_termin + '%'
            },
            label: 'Bisnis - Termin 30 Hari',
            sortable: true,
            align: 'left',
            rowClass: 'text-left'
          }
        ]
      },

      marginPercentageDetail: {
        columns: [
          {
            name: 'date',
            field: (row) => {
              return `<div>${commonDate({
                date: row.data_after.updated_at
              })}</div>
              <div class="text-caption text-grey-7">${dateTime(row.data_after.updated_at)}</div>`
            },
            label: 'Tanggal Diubah',
            sortable: true,
            align: 'left',
            rowClass: 'text-left'
          },
          {
            name: 'marginRetail',
            field: (row) => {
              return `<strong class="text-primary">${row.data_after.margin_retail}</strong>`
            },
            label: 'Retail - Tunai',
            sortable: true,
            align: 'center',
            rowClass: 'text-center'
          },
          {
            name: 'marginBusiness',
            field: (row) => {
              return `<strong class="text-primary">${row.data_after.margin_business}</strong>`
            },
            label: 'Bisnis - Tunai',
            sortable: true,
            align: 'center',
            rowClass: 'text-center'
          },
          {
            name: 'marginBusinessTermin',
            field: (row) => {
              return `<strong class="text-primary">${row.data_after.margin_business_termin}</strong>`
            },
            label: 'Bisnis - Termin 30 Hari',
            sortable: true,
            align: 'center',
            rowClass: 'text-center'
          },
          {
            name: 'actor',
            field: (row) => {
              return `<div>${row.user.name}</div>
              <div class="text-primary text-caption">${row.role.name}</div>`
            },
            label: 'Aktor',
            sortable: false,
            align: 'left',
            rowClass: 'text-left'
          }
        ]
      }
    },

    formDefault: JSON.parse(JSON.stringify(initForm)),
    form: { ...initForm }
  }
}
